import React, { useCallback } from 'react';
import FlatList from 'flatlist-react/lib';
import Fire from './Fire';
import sortingArrowIcon from '../../../assets/icons/sorting-arrows-icon.png';
import refreshIcon from '../../../assets/icons/refresh-icon.png';
import Spinner from '../../Spinner';
import { useFireList } from './useFireList';
import './AllFires.scss';

const MemoizedFire = React.memo(Fire);

export default function AllFires({ fires, panel, setPanel, map, user, setUser, modal, setModal, getFires }) {
  const {
    search,
    setSearch,
    isNewestFirst,
    setIsNewestFirst,
    statusFilter,
    setStatusFilter,
    sortFilter,
    setSortFilter,
    refreshing,
    filteredFires,
    handleRefresh
  } = useFireList(fires);

  const handleRefreshCallback = useCallback(() => {
    handleRefresh(getFires, map);
  }, [handleRefresh, getFires, map]);

  const renderFireRow = useCallback(
    (fire) => (
      <MemoizedFire
        fire={fire}
        panel={panel}
        setPanel={setPanel}
        map={map}
        user={user}
        setUser={setUser}
        modal={modal}
        setModal={setModal}
      />
    ),
    [panel, setPanel, map, user, setUser, modal, setModal]
  );

  return (
    <div className="all-fires">
      <div className="all-fires-search">
        <input
          type="text"
          className="all-fires-search-input"
          placeholder="Search by fire name"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="all-fires-filters">
        <div className="all-fires-filters-left">
          <img
            src={sortingArrowIcon}
            className="all-fires-filters-left-icon"
            style={{
              transform: isNewestFirst ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
              cursor: 'pointer',
            }}
            onClick={() => setIsNewestFirst((x) => !x)}
          />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '0.1rem' }}>
            <div style={{ color: 'black', fontWeight: 'bold', fontSize: '0.7rem',  }}>SORT</div>
            <select
              className="all-fires-filters-left-select"
              value={sortFilter}
              onChange={(e) => setSortFilter(e.target.value)}
            >
              <option value="acres-burned">Acres Burned</option>
              <option value="discovery-time">Discovery Time</option>
              <option value="last-updated">Last Updated</option>
              <option value="containment">Containment %</option>
            </select>
          </div>
          <img
            src={refreshIcon}
            className="all-fires-filters-left-refresh"
            style={{
              transform: refreshing ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
              cursor: 'pointer',
              alignSelf: 'end',
              marginBottom: 3
            }}
            onClick={handleRefreshCallback}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: '0.1rem' }}>
          <div style={{ color: 'black', fontWeight: 'bold', fontSize: '0.7rem',  }}>FILTER</div>
          <select
            value={statusFilter}
            className="all-fires-filters-left-select"
            onChange={e => setStatusFilter(e.target.value)}
          >
            <option value="all">All Fires</option>
            <option value="active">Active Only</option>
            <option value="contained">Contained Only</option>
          </select>
        </div>
      </div>

      <div className="all-fires-list">
        {refreshing ? (
          <div style={{ paddingTop: '1rem' }}>
            <Spinner />
          </div>
        ) : (
          <FlatList
            list={filteredFires}
            renderItem={renderFireRow}
            renderOnScroll
            renderWhenEmpty={() => (
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                padding: '2rem',
                textAlign: 'center',
                color: '#666'
              }}>
                <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                  No fires found
                </div>
                <div style={{ fontSize: '0.9rem' }}>
                  Try adjusting your search or filter criteria
                </div>
              </div>
            )}
          />
        )}
      </div>
    </div>
  );
}
